export default __webpack_public_path__ + "static/media/mon_256.46bfd8c0.png";